"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
const logger_1 = require("./logger");
const reporters_1 = require("./reporters");
const gtmReporter_1 = require("./reporters/gtmReporter");
const amplifyReporter_1 = require("./reporters/amplifyReporter");
const datadogReporter_1 = require("./reporters/datadogReporter");
const logReporter_1 = require("./reporters/logReporter");
__exportStar(require("./types"), exports);
__exportStar(require("./reporters"), exports);
__exportStar(require("./logger"), exports);
let initialized = false;
/**
 * Initializes the logger and reporters.
 * @param config Reporter config options.
 */
function init(config) {
    var _a, _b, _c, _d, _e, _f;
    // Some reporters don't like being initialized multiple times.
    if (initialized) {
        return;
    }
    initialized = true;
    // Log Reporter enabled by default.
    const logReporterConfig = (_b = (_a = config.reporters) === null || _a === void 0 ? void 0 : _a.log) !== null && _b !== void 0 ? _b : true;
    if (logReporterConfig !== false) {
        reporters_1.reporters['log'] = (0, logReporter_1.logReporter)(config, typeof logReporterConfig === 'boolean' ? {} : logReporterConfig);
    }
    if ((_c = config.reporters) === null || _c === void 0 ? void 0 : _c.datadog) {
        reporters_1.reporters['datadog'] = (0, datadogReporter_1.datadogReporter)(config, config.reporters.datadog);
    }
    if ((_d = config.reporters) === null || _d === void 0 ? void 0 : _d.amplify) {
        reporters_1.reporters['amplify'] = (0, amplifyReporter_1.amplifyReporter)(config, config.reporters.amplify);
    }
    if ((_e = config.reporters) === null || _e === void 0 ? void 0 : _e.gtm) {
        reporters_1.reporters['gtm'] = (0, gtmReporter_1.gtmReporter)(config, typeof config.reporters.gtm === 'boolean' ? {} : config.reporters.gtm);
    }
    const defaultMetadata = {
        ...((_f = config.defaultMetadata) !== null && _f !== void 0 ? _f : {}),
        service: config.service,
        environment: config.environment,
        version: config.version,
    };
    // Sets the global log level, if specified.
    if (config.logLevel) {
        (0, logger_1.setLogLevel)(config.logLevel);
    }
    // Sets the global event level, if specified.
    if (config.eventLevel) {
        (0, reporters_1.setEventLevel)(config.eventLevel);
    }
    (0, reporters_1.addMetadata)(defaultMetadata);
}
exports.init = init;
//# sourceMappingURL=index.js.map